import { secureGet, securePut } from '../utils/HttpUtils';

const apiUrl = '/v1/private/guarantees/regulacion-sepyme';

export interface RegulacionSepymeData {
  authorizedRiskFund: number | null;
  maximumLeverage: number | null;
  maximumPerPartner: number | null;
  updatedAt: string | null;
}

export interface RegulacionSepymeResponse {
  success: boolean;
  data?: RegulacionSepymeData;
  message?: string;
}

const mapResponseData = (data: any): RegulacionSepymeData => ({
  authorizedRiskFund: data?.authorizedRiskFund ?? data?.authorized_risk_fund ?? null,
  maximumLeverage: data?.maximumLeverage ?? data?.maximum_leverage ?? null,
  maximumPerPartner: data?.maximumPerPartner ?? data?.maximum_per_partner ?? null,
  updatedAt: data?.updatedAt ?? data?.updated_at ?? null,
});

export const getRegulacionSepyme = async (): Promise<RegulacionSepymeResponse> => {
  try {
    const response = await secureGet(apiUrl);
    if (response.success && 'data' in response) {
      return {
        success: true,
        data: mapResponseData(response.data),
      };
    }
    return {
      success: false,
      message: response.message || 'Error al obtener la configuración',
    };
  } catch (error: any) {
    console.error('Error getting Regulacion SePyME:', JSON.stringify(error, null, 2));
    return {
      success: false,
      message: error?.response?.data?.message || 'Error al obtener la configuración',
    };
  }
};

export const updateRegulacionSepyme = async (
  data: Pick<RegulacionSepymeData, 'authorizedRiskFund' | 'maximumLeverage' | 'maximumPerPartner'>
): Promise<RegulacionSepymeResponse> => {
  try {
    const payload = {
      authorized_risk_fund: data.authorizedRiskFund,
      maximum_leverage: data.maximumLeverage,
      maximum_per_partner: data.maximumPerPartner,
    };

    const response = await securePut(apiUrl, payload);
    if (response.success && 'data' in response) {
      return {
        success: true,
        data: mapResponseData(response.data),
      };
    }
    return {
      success: false,
      message: response.message || 'Error al actualizar la configuración',
    };
  } catch (error: any) {
    console.error('Error updating Regulacion SePyME:', JSON.stringify(error, null, 2));
    return {
      success: false,
      message: error?.response?.data?.message || 'Error al actualizar la configuración',
    };
  }
};
